import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { verifyOTP } from '../../features/auth/registerSlice';

const OtpStep = ({ onVerified, phone, onResend }: { onVerified: () => void, phone: string, onResend: () => void }) => {
  const { t } = useTranslation();
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const [timer, setTimer] = useState(60); 

    const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleVerifyOTP = async () => {
    const regex = /^\d{4}$/;
    if (!regex.test(verificationCode)) {
      toast.error(t("otp-error"));
      return;
    }

    try {
      if (verificationCode) {
        const res=await dispatch(verifyOTP({phone,otp:verificationCode})).unwrap()
        if(res?.success){
          toast.success(t("verified"));
        onVerified();
        }
      } else {
        setError(t("otp-error"));
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  const handleResend = () => {
    onResend();
    setTimer(60); 
    toast.success(t("otp-sent-again"));
  };

  return (
    <div>
      <h2 className='text-2xl font-semibold mb-3'>{t("otp")}</h2>
      <label className='text-lg font-medium mb-1'>{t("verification-code")}</label>
      <input
        type='text'
        value={verificationCode}
        onChange={(e) => {
          const val = e.target.value;
          if (/^\d{0,6}$/.test(val)) {
            setVerificationCode(val);
          }
        }}
        maxLength={6}
        className='border w-full p-3 rounded-lg bg-white'
      />
      {error && <p className='text-red-500 text-sm mt-2'>{error}</p>}

      <button
        onClick={handleVerifyOTP}
        className={`w-full mt-4 py-3 rounded-lg text-white ${verificationCode.length >= 4 ? 'bg-secondry' : 'bg-gray-400 cursor-not-allowed'}`}
        disabled={verificationCode.length < 4}
      >
        {t("continue")}
      </button>

      <div className="mt-4 text-center">
        {timer > 0 ? (
          <p className="text-gray-500 text-sm">
            {t("resend-after")} {timer} {t("seconds")}
          </p>
        ) : (
          <button
            onClick={handleResend}
            className="text-secondry font-medium hover:underline"
          >
            {t("resend-code")}
          </button>
        )}
      </div>
    </div>
  );
};

export default OtpStep;
